import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { Switch } from "../ui/switch";

// House players: the Players Room-run seats on the main-lobby ring games (disclosed in the Terms).
export const HousePlayersPanel = () => {
  const [s, setS] = useState(null);
  const load = () => api.get("/api/admin/house-players").then((r) => setS(r.data)).catch((e) => toast.error(errorMessage(e)));
  useEffect(() => { load(); const id = setInterval(load, 15000); return () => clearInterval(id); }, []);
  const flip = async (on) => {
    try { setS((await api.patch("/api/admin/house-players", { on })).data); toast.success(on ? "House players are joining the ring games" : "House players will leave at the end of their hands"); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div className="gold-card rounded-2xl p-6 flex flex-col gap-4" data-testid="admin-house-players">
      <div className="flex items-start gap-4">
        <div className="flex-1">
          <div className="font-display text-xl gold-text">House players</div>
          <p className="text-xs text-slate-400 mt-1">Keep the main-lobby ring games running. One seat is always left empty, and a house player gives up its chair at the end of the hand when a real player sits. Max 3 hours a table, 5 hours a day each.</p>
        </div>
        {s && <Switch checked={s.on} onCheckedChange={flip} data-testid="admin-house-switch" />}
      </div>
      {!s ? <span className="text-xs text-slate-500">Loading…</span> : (
        <>
          <div className="flex gap-6 text-xs text-slate-300" data-testid="admin-house-summary">
            <span>{s.players} players</span>
            <span>{s.styles.tight} tight · {s.styles.balanced} in between · {s.styles.loose} loose</span>
            <span>{s.aggressive} extra aggressive</span>
            <span className="text-emerald-300" data-testid="admin-house-seated-count">{s.seated.length} seated now</span>
          </div>
          {s.seated.length > 0 && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-[11px] text-slate-400" data-testid="admin-house-seated">
              {s.seated.map((p) => <span key={p.name}>{p.name} · {p.table_id} · {p.minutes}m</span>)}
            </div>
          )}
        </>
      )}
    </div>
  );
};
